import React, {useEffect} from "react";
import UserManagerPage from "./UserManagerPage";
import {useRouteMatch} from "react-router";
import {useMutation, useQuery} from "@apollo/client";
import {useHistory} from "react-router-dom";
import {IonButton, IonInput, IonItem, IonLoading, useIonAlert} from "@ionic/react";
import {USER_GET_RULE_DATA_QUERY, USER_MANAGER_UPDATE_RULE} from "../../schemas/userManager";


const UserManagerEditRule: React.FC<any> = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [alert, dismissAlert] = useIonAlert();
    const match:any = useRouteMatch();
    const [ruleId, setRuleId] = React.useState<number>();
    const [details, setDetails] = React.useState<string | undefined | null>(undefined);
    const {loading:ruleLoading, error:ruleError, data: ruleData, refetch} = useQuery(USER_GET_RULE_DATA_QUERY, {variables: {id: ruleId}});
    const [updateRuleMutation] = useMutation(USER_MANAGER_UPDATE_RULE);


    useEffect(() => {
        if (ruleData) {
            setDetails(ruleData.getRuleData.details);
        }
    }, [ruleData]);

    useEffect(() => {
        if (match.params.id) {
            setRuleId(Number(match.params.id));
        }
    }, []);
    useEffect(() => {
        setIsLoading(ruleLoading);
    }, [ruleLoading]);

    const updateRule = async () => {
        setIsLoading(true);
        await updateRuleMutation({variables: {data: {id: ruleId, details: details}}});
        await refetch();
        setIsLoading(false);
        await alert("Rule updated successfully.");
    };

    return (
        <UserManagerPage page={'edit-rule'}>
            <IonLoading isOpen={isLoading} />
            {!ruleLoading && ruleData && ruleData.getRuleData &&

                <div className="userManagerContent">
                    <h1>Edit Rule: {ruleData.getRuleData.name}</h1>
                    <div style={{backgroundColor: "white", padding: "10px"}}>
                        <p>Update rule information here.</p>
                        <div style={{display: "table"}}>
                            <div style={{display: "table-row"}}>
                                <div style={{display: "table-cell"}}>
                                    <b>Details:</b>
                                </div>
                                <div style={{display: "table-cell", minWidth: 350}}>
                                    <IonItem>
                                        <IonInput value={details} onIonChange={(e) => setDetails(e.detail.value)}></IonInput>
                                    </IonItem>
                                </div>
                            </div>
                        </div>
                        <p style={{textAlign: 'right'}}>
                            <IonButton fill="outline" onClick={() => history.goBack()}>Go Back</IonButton>
                            <IonButton onClick={() => updateRule()}>Update Rule</IonButton>
                        </p>
                    </div>
                </div>
            }
        </UserManagerPage>
    );
};


export default UserManagerEditRule;